import { Injectable } from '@angular/core';

import {
  ITranscriptWord,
  TranscriptWord,
  FormattedTranscriptWord,
  IFormattedTranscriptWord,
  ITranscriptionResult,
} from '@models/grade-unit/transcript';

@Injectable({
  providedIn: 'root',
})
export class TranscriptService {
  public getTextTimeArrayFromTranscription(
    transcription: ITranscriptionResult,
  ): ITranscriptWord[] {
    const transcriptWordList: ITranscriptWord[] = [];
    transcription?.items?.forEach((item, index) => {
      // add punctuation to previous word
      if (item.type === 'punctuation' && transcriptWordList.length > 0) {
        transcriptWordList[transcriptWordList.length - 1].content +=
          item.alternatives[0].content;
        return;
      }

      const word = new TranscriptWord({
        id: index,
        // add 0.3 seconds to start time to give lead up to word that is going to be spoken
        start:
          parseFloat(item.start_time) >= 0.3
            ? `${parseFloat(item.start_time) - 0.3}`
            : item.start_time,
        // Extend the end time by 0.3 seconds to give a little more time to for the highlight to occur
        end:
          parseFloat(item.end_time) - parseFloat(item.start_time) >= 0.3
            ? item.end_time
            : `${parseFloat(item.start_time) + 0.3}`,
        // sorting by confidence and grab first result
        content: item.alternatives.sort(
          (a, b) => parseFloat(a.confidence) - parseFloat(b.confidence),
        )[0].content,
      });
      transcriptWordList.push(word);
    });

    return transcriptWordList;
  }

  public mapFormattingToTemplate(
    wordList: ITranscriptWord[],
  ): IFormattedTranscriptWord[] {
    const formattedList: IFormattedTranscriptWord[] = [];
    let formattedWord = new FormattedTranscriptWord();
    let isInHeader = false;
    let isInParagraph = false;
    wordList.forEach((word) => {
      if (word.hasHeader && word.hasNewline) {
        if (formattedWord.wordList.length) {
          formattedList.push(formattedWord);
        }
        formattedWord = new FormattedTranscriptWord();
        isInHeader = true;
        formattedWord.hasHeader = true;
      } else if (
        word.hasHeader !== isInHeader ||
        (word.hasNewline && isInParagraph)
      ) {
        if (formattedWord.wordList.length) {
          formattedList.push(formattedWord);
        }
        // clear group
        formattedWord = new FormattedTranscriptWord();
        isInParagraph = false;
        isInHeader = false;
        formattedWord.hasNewline = false;
        formattedWord.hasHeader = false;

        // set header group
        if (word.hasHeader) {
          formattedWord.hasHeader = true;
          isInHeader = true;
        }
      }

      // set p group
      if (!isInHeader && !isInParagraph) {
        formattedWord.hasNewline = true;
        isInParagraph = true;
      }
      // set word
      formattedWord.wordList.push(word);
    });

    if (formattedWord.wordList.length) {
      formattedList.push(formattedWord);
    }

    return formattedList;
  }

  // TODO: Look at replacing splice with slice to make object not mutate parent while still being performant.
  /**
   * Remove empty contents and update end time of previous entry.
   */
  public sanitizeTextTimeData(transcriptWordList: ITranscriptWord[]): void {
    for (let i = 0; i < transcriptWordList.length; i++) {
      if (!transcriptWordList[i].content) {
        if (i === 0 && transcriptWordList.length > 1) {
          transcriptWordList[i + 1].start = transcriptWordList[i].start;
          transcriptWordList.splice(i, 1);
          i--;
        } else {
          if (i > 0) {
            transcriptWordList[i - 1].end = transcriptWordList[i].end;
            transcriptWordList.splice(i, 1);
            i--;
          }
        }
      }
    }
  }
}
